import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';

import { H3 } from 'components/core/Typography';

import './Popover.scss';

export default function Popover({
	children, className, position, showing, title
}) {
	return (
		<CSSTransition
			classNames="transition-fade-in"
			in={showing}
			unmountOnExit
			timeout={150}
		>
			<div
				className={
					classnames(
						'legacy-popover',
						className,
						{ [position]: position }
					)
				}
			>
				<div className="arrow" />
				{!!title &&
				<H3
					last
					className="popover-title"
				>
					{title}
				</H3>
				}
				<div className="popover-content">
					{children}
				</div>
			</div>
		</CSSTransition>
	);
}

Popover.propTypes = {
	position: PropTypes.oneOf(['top', 'bottom']),
	children: PropTypes.node,
	className: PropTypes.string,
	showing: PropTypes.bool,
	title: PropTypes.string
};
